import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@bingads-webui-react/fabric-control';
import { GeneratedUI } from '@bingads-webui-campaign-react/ui-generator';
import { summaryPageComponentTypes } from '@bingads-webui-campaign-react/summary-page';
import { WIZARD_EVENTS, useWizardService } from '@bingads-webui-react/wizard';
import { StepHeader } from '@bingads-webui-campaign-react/display-plus-campaigns';
import { buildSchema } from './schema';
import { useSummarySchemaData } from './use-summary-schema-data';
import { STEP_PATHS } from '../../constants';

export const SummaryStep = ({
  data,
}) => {
  const schemaData = useSummarySchemaData({ data });

  const { send } = useWizardService();

  const onShoppingHeaderActionClick = useCallback(() => send(WIZARD_EVENTS.NAVIGATE_TO, {
    stepId: STEP_PATHS.CAMPAIGN_SETTINGS,
  }), [send]);

  const onTargetingHeaderActionClick = useCallback(() => send(WIZARD_EVENTS.NAVIGATE_TO, {
    stepId: STEP_PATHS.TARGET_SETTINGS,
  }), [send]);

  const onBudgetBidHeaderActionClick = useCallback(() => send(WIZARD_EVENTS.NAVIGATE_TO, {
    stepId: STEP_PATHS.BUDGET_AND_BIDS,
  }), [send]);

  const options = useMemo(() => ({
    onShoppingHeaderActionClick,
    onTargetingHeaderActionClick,
    onBudgetBidHeaderActionClick,
  }), [onShoppingHeaderActionClick, onTargetingHeaderActionClick, onBudgetBidHeaderActionClick]);

  const schema = useMemo(() => buildSchema(options), [options]);

  return (
    <div className="summary-step" >
      <Stack tokens={{ childrenGap: 22 }}>
        <Stack>
          <StepHeader
            title={_TL_('Prepare for success!')}
            description={_TL_('Here\'s a summary of everything in your campaign. All objects are available, but campaign is not live yet.')}
          />
        </Stack>
        {data ?
          <div className="summary-sections">
            <GeneratedUI schema={schema} customComponentTypes={summaryPageComponentTypes} {...schemaData} />
          </div>
          : null
        }
      </Stack>
    </div>
  );
};

SummaryStep.propTypes = {
  data: PropTypes.shape({}),
};

SummaryStep.defaultProps = {
  data: null,
};
